/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetVectorStoreFileContentRequest = {
  vectorStoreId: string;
  fileId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetVectorStoreFileContentRequest$inboundSchema: z.ZodType<
  GetVectorStoreFileContentRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  vector_store_id: z.string(),
  file_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "vector_store_id": "vectorStoreId",
    "file_id": "fileId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetVectorStoreFileContentRequest$Outbound = {
  vector_store_id: string;
  file_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetVectorStoreFileContentRequest$outboundSchema: z.ZodType<
  GetVectorStoreFileContentRequest$Outbound,
  z.ZodTypeDef,
  GetVectorStoreFileContentRequest
> = z.object({
  vectorStoreId: z.string(),
  fileId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    vectorStoreId: "vector_store_id",
    fileId: "file_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getVectorStoreFileContentRequestToJSON(
  getVectorStoreFileContentRequest: GetVectorStoreFileContentRequest,
): string {
  return JSON.stringify(
    GetVectorStoreFileContentRequest$outboundSchema.parse(
      getVectorStoreFileContentRequest,
    ),
  );
}
export function getVectorStoreFileContentRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetVectorStoreFileContentRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetVectorStoreFileContentRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetVectorStoreFileContentRequest' from JSON`,
  );
}
